// extracted by mini-css-extract-plugin
module.exports = {"custom_select":"style_custom_select__2IGkk","options":"style_options__2rzkX"};